import React, { useEffect, useState, useMemo } from "react";
import Banner from "../../components/banner";
import ProductItem from "../../components/productItem";
import {
  categoryGet_req,
  filterProducts_req,
  getFilterSize_req,
  search_req,
} from "../../api/api";
import Page from "../../components/Page";
import SelectCustom from "../../components/select";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { useRouter } from "next/router";
import { useIntl } from "react-intl";
import NotFoundIcon from "../../assets/images/browser.png";
import LeftArrow from "../../assets/images/icons/left-chevron.png";
import RightArrow from "../../assets/images/icons/right-chevron.png";

const Shop = (query) => {
  const router = useRouter();
  const intl = useIntl();

  const [productList, setProductList] = useState([]);
  const [productsPage, setProductsPage] = useState(null);
  const [priceState, setPriceState] = useState({
    minPrice: query?.minPrice ? query.minPrice : "",
    maxPrice: query?.maxPrice ? query.maxPrice : "",
  });
  const [allCategory, setAllCategory] = useState([]);
  const [changeCategory, setChangeCategory] = useState("");
  const [changeSize, setChangeSize] = useState(
    query?.changeSize ? query.changeSize : ""
  );
  const [sizeData, setSizeData] = useState([]);

  const locale = useSelector((state) => state.global.locale);
  const currentPageQuery = router.query.id;
  const queryData = query.item;

  const onchangeRadio = async (evt) => {
    const value = Number(evt.target.value);
    setChangeCategory((evt.target.name = value));
    setChangeSize("");
    router.push(
      `/shop/1?&item=${value}${
        priceState.minPrice > 0 ? `&minPrice=${priceState.minPrice}` : ""
      }${priceState.maxPrice > 0 ? `&maxPrice=${priceState.maxPrice}` : ""}`
    );
    getFilterSizeData(value);
  };
  const getFilterSizeData = async (value) => {
    const dataValue = Number(value);
    const filterReq = await getFilterSize_req([dataValue]);
    setSizeData(filterReq.data);
  };
  const onchangeRadioSize = async (evt) => {
    const sizeValue = Number(evt.target.value);
    setChangeSize((evt.target.name = sizeValue));
    router.push(
      `/shop/1?item=${query.item}&changeSize=${sizeValue}${
        priceState.minPrice > 0 ? `&minPrice=${priceState.minPrice}` : ""
      }${priceState.maxPrice > 0 ? `&maxPrice=${priceState.maxPrice}` : ""}`
    );
    filteredData([queryData], sizeValue);
  };

  useEffect(() => {
    getFilterSizeData(query.item);
  }, []);

  const handleChangePrice = async (evt) => {
    const value = evt.target.value;

    if (evt.target.name === "minPrice") {
      router.push(
        `/shop/1?item=${
          router.query.item ? router.query.item : changeCategory
        }${changeSize > 0 ? `&changeSize=${changeSize}` : ""}${
          value > 0 ? `&minPrice=${value}` : ""
        }${priceState?.maxPrice > 0 ? `&maxPrice=${priceState.maxPrice}` : ""}`
      );
    }
    if (evt.target.name === "maxPrice") {
      router.push(
        `/shop/1?item=${
          router.query.item ? router.query.item : changeCategory
        }${changeSize > 0 ? `&changeSize=${changeSize}` : ""}${
          priceState.minPrice > 0 ? `&minPrice=${priceState.minPrice}` : ""
        }${value > 0 ? `&maxPrice=${value}` : ""}`
      );
    }

    setPriceState({
      ...priceState,
      [evt.target.name]: value,
    });
  };

  const getCategoryReq = async () => {
    const getCategoryReqData = await categoryGet_req();
    setAllCategory(getCategoryReqData);
  };

  useEffect(() => {
    getCategoryReq();
  }, [locale]);

  const filteredData = async (data, first, page) => {
    const dataQuery = Number(data);
    const filterReq = await filterProducts_req(
      data ? [dataQuery] : [],
      first ? first : undefined,
      priceState,
      currentPageQuery ? currentPageQuery : page
    );
    setProductsPage(filterReq.data);
    setProductList(filterReq.data.filteredProducts);
  };

  useEffect(() => {
    filteredData(queryData, changeSize);
  }, [query]);

  const handleClick = async (data) => {
    const index = data.selected;

    if (router?.query?.item) {
      router.push(
        `/shop/${index + 1}?item=${
          router.query.item ? router.query.item : changeCategory
        }${changeSize > 0 ? `&changeSize=${changeSize}` : ""}${
          priceState.minPrice > 0 ? `&minPrice=${priceState.minPrice}` : ""
        }${priceState.maxPrice > 0 ? `&maxPrice=${priceState.maxPrice}` : ""}`
      );
      filteredData(queryData, changeSize, index + 1);
    }
  };

  const meta = useMemo(() => {
    const { item } = router.query;

    let metaOjb = {
      5: {
        title: intl.messages.chees_5,
        description: intl.messages.chees_desc5,
      },
      6: {
        title: intl.messages.backgamon_6,
        description: intl.messages.backgamon_desc6,
      },
      56: {
        title: intl.messages.induvidual_56,
        description: intl.messages.induvidual_desc56,
      },
      50: {
        title: intl.messages.chees_author,
        description: intl.messages.chees_author_desc,
      },
      51: {
        title: intl.messages.order_chees,
        description: intl.messages.order_chees_desc,
      },
      52: {
        title: intl.messages.order_chees,
        description: intl.messages.order_desc,
      },
      53: {
        title: intl.messages.table,
        description: intl.messages.table_desc,
      },
      58: {
        title: intl.messages.shelve,
        description: intl.messages.shelve_desc,
      },
      67: {
        title: intl.messages.epoxy,
        description: intl.messages.epoxy_desc,
      },
      48: {
        title: intl.messages.author_backgamon,
        description: intl.messages.author_backgamon_desc,
      },
      49: {
        title: intl.messages.table_backgamon,
        description: intl.messages.table_backgamon_desc,
      },
      78: {
        title: "Պատվիրել Էպօքսիդե Նարդի | Handle Brand",
        description:
          "Պատվիրեք ընկուզենու փայտից և էպօքսիդային լուծույթից պատրաստված նարդիները Handle-ից | Գնեք օնլայն կամ զանգահարեք +374 33 58 58 50",
      },
      55: {
        title: "Գնել Անհատական Շախմատ | Handle Brand",
        description:
          "Գնեք հաճարենու փայտից պատրաստված անհատական շախմատները Handle-ից | Անվանական նվերների համար զանգահարեք  033 58 58 50",
      },
      56: {
        title: "Պատվիրել Անհատական Նարդի | Handle Brand",
        description:
          "Գնեք հաճարենու փայտից պատրաստված անհատական նարդի Handle-ից | Պատվերների համար Բուզանդի 1/3 կամ զանգահարեք  033 58 58 50",
      },
      4: {
        title: "Փայտե Ժամացույցների Մեծ Տեսականի | Handle Brand",
        description:
          "Ցանկանում ես գնել փայտե ժամացույց <<Հենդլ>> բրենդը ներկայացնում է պատի փայտե ժամացույցների լայն տեսականի | Պատվիրել հիմա",
      },
      3: {
        title: "Հուշանվերների Լայն Տեսականի | Handle Brand",
        description:
          "Գնել փայտե հուշանվեր | Handle ի մեծ տեսականին կզարմացնի Ձեզ | Փորագրված ձեռնափայտեր ցանկացած ճաշակի համար | Ավելին այստեղ",
      },
      2: {
        title: "Շախմատի և Նարդու Խաղաքարեր | Handle Brand",
        description:
          "Գնեք նարդու և շախմատի խաղաքարեր ցանկացած դիզայնով | Շախմատի խաղաքարերի մեծ տեսկանի Handle.am - ում | Գնել հիմա",
      },
      1: {
        title: "Գինու և Կոնյակի Տակառների Մեծ Տեսականի | Handle Brand",
        description:
          "Գնել կոնյակի և գինու տակառ Handle - ից | Կոնյակի տակառներ, գինու տակառներ, դուբի տակառներ խմիչքների համար | Տեսեք ավելին այստեղ",
      },
    };

    return metaOjb[item];
  }, [router.query]);

  return (
    <Page meta={meta}>
      <div className="shop">
        <Banner
          title={`${
            query?.discount === "discount"
              ? intl.messages.discount
              : intl.messages.shop
          }`}
          currentPage={`${
            query?.discount === "discount"
              ? intl.messages.discount
              : intl.messages.shop
          }`}
        />
        <div className="wrapper">
          <div className="filter-section flex flex-ai-center flex-jc-between">
            <div className="filter-left flex flex-ai-center">
              {/*<div className="filter-title">{intl.messages.filter}:</div>*/}

              <SelectCustom
                label={intl.messages.category}
                handleChange={onchangeRadio}
                name="changeCategory"
                value={queryData ? queryData : changeCategory}
                children={
                  <>
                    {/* <option value="Select One" disabled>
                    Select One
                  </option> */}
                    {allCategory?.data?.map((item, index) => (
                      <option
                        value={item.categoryId}
                        selected={
                          changeCategory
                            ? changeCategory === item.categoryId
                            : queryData === item.id
                        }
                      >
                        {item.name}
                      </option>
                    ))}
                  </>
                }
              />
              {sizeData?.length > 0 && (
                <div className="filter-category">
                  <SelectCustom
                    label={intl.messages.size}
                    handleChange={onchangeRadioSize}
                    name={intl.messages.size}
                    value={changeSize}
                    children={
                      <>
                        <option
                          value=""
                          disabled
                        >
                          {intl.messages.selectOne}
                        </option>
                        {sizeData?.map((item, index) => (
                          <option
                            value={item.id}
                            selected={item.id}
                          >
                            {item.name}
                          </option>
                        ))}
                      </>
                    }
                  />
                </div>
              )}

              <div className="field-item price-range">
                <span>{intl.messages.priceRange}</span>
                <div>
                  <input
                    type="number"
                    placeholder={intl.messages.from}
                    onChange={handleChangePrice}
                    value={priceState.minPrice}
                    name="minPrice"
                  />
                  <input
                    type="number"
                    placeholder={intl.messages.to}
                    onChange={handleChangePrice}
                    value={priceState.maxPrice}
                    name="maxPrice"
                  />
                </div>
              </div>
            </div>
            {/* <div className="filter-right">
            <div className="field-item search-field">
              <span>{intl.messages.search}</span>
              <input
                type="text"
                onChange={handleChange}
                value={state.search}
                name="search"
              />
            </div>
          </div> */}
          </div>

          <div className="flex flex-wrap">
            {productList.length > 0 ? (
              productList?.map((item) => (
                <ProductItem
                  image={item.image}
                  name={item.title}
                  size={item.size}
                  price={item.price}
                  code={item.code}
                  categoryName={item.categoryName}
                  tag={item.discount}
                  oldPriceData={true}
                  id={item.id}
                  currency={item.currency}
                  changeSize={changeSize}
                  minPrice={priceState.minPrice}
                  maxPrice={priceState.maxPrice}
                />
              ))
            ) : (
              <div className="product-not-found">
                <img
                  src={NotFoundIcon.src}
                  alt=""
                />
                <h4>{intl.messages.productNotFound}</h4>
              </div>
            )}
          </div>

          {productsPage?.pagesCount > 1 && (
            <ReactPaginate
              previousLabel={
                <img
                  src={LeftArrow.src}
                  alt=""
                />
              }
              nextLabel={
                <img
                  src={RightArrow.src}
                  alt=""
                />
              }
              breakLabel={`...`}
              pageCount={productsPage?.pagesCount}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              onPageChange={(data) => handleClick(data)}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
              forcePage={currentPageQuery - 1}
            />
          )}
        </div>
      </div>
    </Page>
  );
};
Shop.getInitialProps = ({ query }) => {
  return query;
};
export default Shop;
